
var Promise = require("promise");
var url = require("url");
var asap = require("asap");
var window = require("global");

var Model = require("../types/Model.js");

module.exports = Model({
	name: "backgroundsocket",
	init: init,
	uninit: uninit,
	listeners: listeners,

	initSocket: initSocket,
	listenSocket: listenSocket,
	openSocket: openSocket,
	closeSocket: closeSocket
});

function init() {
	this
		.initSocket()
		.then(openSocket.bind(this))
		.then(listenSocket.bind(this))
		.then(handle_init_success.bind(this))
		.catch(handle_init_error.bind(this));
}

function uninit() {
	this.closeSocket();
}

function listeners() {
	return {
		"networkstatus:online": openSocket
	};
}

function initSocket() {
	if (!window.aetonixsocket)
		return Promise.reject(new Error("No Socket Plugin Available"));

	return new Promise(function (resolve, reject) {
		window.aetonixsocket.initSocket(resolve, reject);
	});
}

function openSocket() {
	if (!window.aetonixsocket)
		return Promise.reject(new Error("No Socket Plugin Available"));

	var bghost = this.config.bghost;
	var token = this.config.token;

	if (!bghost)
		return Promise.reject(new Error("No socket host specified in config"));

	return new Promise(function (resolve, reject) {
		var parsed = url.parse(bghost);

		var hostname = parsed.hostname;
		var port = parsed.port;

		window.aetonixsocket.openSocket(hostname, port, token, resolve, reject);
	});
}

function closeSocket() {
	if (!window.aetonixsocket)
		return Promise.reject(new Error("No Socket Plugin Available"));

	return new Promise(function (resolve, reject) {
		window.aetonixsocket.closeSocket(resolve, reject);
	});
}

function listenSocket() {
	if (!window.aetonixsocket)
		return Promise.reject(new Error("No Socket Plugin Available"));

	return new Promise(function (resolve, reject) {
		window.aetonixsocket.listen(handle_socket_event.bind(this), reject);
		asap(resolve);
	}.bind(this));
}

function handle_init_error(e) {
	this.dispatch("error", e);
	this.push(false);
}

function handle_init_success() {
	this.push(true);
}

function handle_socket_event(data) {
	var lines = data.split("\n");
	lines.forEach(function (line) {
		if (line) this.dispatch("line", line);
	}, this);
}
